var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseContainer',[_c('div',{class:_vm.$style.text},[_vm._v(" "+_vm._s(_vm.$t('ghost-riders-txt'))+" ")]),_c('div',{class:_vm.$style.video},[_c('BaseVideo',{attrs:{"src":_vm.session.video_src}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }